import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from '../service/auth.service';

import { environment } from '@unico-people/shared/utils/environments';

declare global {
  interface Window { Cypress: any; msw: any }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(): boolean {
      if(!environment?.production && window?.msw) {
      return true;
    }

    if (this.auth.loggedIn()) {
      return true;
    } else {
      this.router.navigate(['/nao-autorizado']);
      return false;
    }
  }
}
